var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative d-inline-block"},[_c('transition',{attrs:{"name":"bounce"}},[_c('div',{key:_vm.quantity,staticClass:"cart-quantity",class:{shrink: _vm.quantity >= 10}},[_vm._v(_vm._s(_vm.quantity || ''))])]),_c('IconCart',{staticClass:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }